import serviceApi from '@/utils/request'
import { getToken } from '@/utils/auth'
import qs from 'qs'
// 获取成员信息
export function getSignPackage (data) {
  return serviceApi.service({
    url: serviceApi.serviceApi + 'weixin.getsignpackage',
    method: 'post',
    data: qs.stringify(data)
  })
}




// WEBPACK FOOTER //
// ./src/api/WeiXin.js